<template>
  <div>
    <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Administração - Cortesias'"
      :titulo="'cortesia'"
    />

    <!--Formulário de Cadastro -->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-journal-text fs-5 icon-text-form"></i>
            <span class="txt-title-form">Dados da Cortesia</span>
          </div>
        </div>
        <form @submit.prevent="onSubmit">
          <div class="row g-2 p-2">
            <div class="col-12 col-sm-12 col-md-12 col-lg-1 col-xl-1">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="codigo"
                  required
                />
                <label>Código</label>
              </div>
            </div>
            <!-- Descrição (50%) - Só ocupa metade em XL, mas 100% nos outros -->
            <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="descricao"
                  required
                />
                <label>Descrição</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="preco_base_peca"
                  @input="preco_base_peca = formatarValor(preco_base_peca)"
                  required
                />
                <label>Preço Base</label>
              </div>
            </div>
            <!-- Preço Final -->
            <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="preco_venda"
                  @input="preco_venda = formatarValor(preco_venda)"
                  required
                />
                <label>Preço Final</label>
              </div>
            </div>
          </div>
          <!-- Segunda Linha -->
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
              <button
                type="submit"
                :disabled="btn_cadastrar"
                class="btn round-btn d-flex align-items-center justify-content-center"
              >
                <i class="bi bi-plus-circle" title="Inserir Acessório"></i>
              </button>
            </div>
            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
              <button
                type="submit"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                :disabled="btn_cadastrar"
              >
                <span>Cadastrar</span>
              </button>
            </div>
            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
              <button
                type="submit"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                :disabled="btn_cadastrar"
              >
                <span>Cadastrar</span>
              </button>
            </div>
          </div>
        </form>
        <div v-if="abrir_modal">
          <Message :msg="msg" v-show="msg" />
        </div>
      </div>
    </div>

    <!--Tabela-->
    <div class="card-container">
      <div class="card">
        <!--Apenas Mobile-->
        <div class="d-md-none">
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <div
              v-for="item in cortesias"
              :key="item.descricao"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                >
                  {{ item.descricao }}
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p class="card-table-item">
                      <strong>Preço Base:</strong>
                      {{ currency(item.preco_base_peca) }}
                    </p>
                    <p class="card-table-item">
                      <strong>Preço Final:</strong>
                      {{ currency(item.preco_venda) }}
                    </p>
                    <button
                      type="button"
                      class="btn round-btn align-self-end"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      @click="editar_cortesia(item)"
                    >
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Apenas Tablet-->
        <div class="d-none d-md-block d-lg-none">
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <div
              v-for="item in cortesias"
              :key="item.descricao"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                >
                  {{ item.descricao }}
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p class="card-table-item">
                      <strong>Preço Base:</strong>
                      {{ currency(item.preco_base_peca) }}
                    </p>
                    <p class="card-table-item">
                      <strong>Preço Final:</strong>
                      {{ currency(item.preco_venda) }}
                    </p>
                    <button
                      type="button"
                      class="btn btn-modal"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      @click="editar_cortesia(item)"
                    >
                      <span>Editar</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Apenas Desktop -->
        <div class="d-none d-lg-block">
          <table class="table rf_texto table-striped" v-if="!isLoading">
            <thead class="d-md-table-header-group">
              <!-- Oculta cabeçalho em mobile -->
              <tr>
                <th scope="col" class="col-md-4 col-lg-3">Descrição</th>
                <th scope="col" class="col-md-2 col-lg-2">Preço Base</th>
                <th scope="col" class="col-md-3 col-lg-3">Preço Final</th>
                <th scope="col" class="col-md-1 col-lg-1 text-center">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in cortesias"
                :key="item.descricao"
                class="table-linha"
              >
                <!-- Celula de Descrição (com cabeçalho para mobile) -->
                <td data-label="Descrição" class="col-12 col-md-4 col-lg-3">
                  <span class="d-md-none fw-bold">Descrição: </span>
                  {{ item.descricao }}
                </td>

                <!-- Celula de Preço Base -->
                <td data-label="Preço Base" class="col-6 col-md-2 col-lg-2">
                  <span class="d-md-none fw-bold">Preço Base: </span>
                  {{ this.currency(item.preco_base_peca) }}
                </td>

                <!-- Celula de Preço Instalado -->
                <td
                  data-label="Preço Instalado"
                  class="col-6 col-md-3 col-lg-3"
                >
                  <span class="d-md-none fw-bold">Preço Final: </span>
                  {{ this.currency(item.preco_venda) }}
                </td>

                <!-- Celula de Ação -->
                <td class="col-12 col-md-1 col-lg-1 text-center text-md-start">
                  <button
                    type="button"
                    class="dropdown-toggle-icon btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editar_cortesia(item)"
                  >
                    <i class="bi bi-pencil-square"></i>
                    <span class="d-md-none">Editar</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="loading-indicator">Carregando...</div>
        </div>
        <pagination
          v-if="cortesias.length"
          :total="totalItems"
          :limit="pageSize"
          :offset="currentPage"
          :totalPages="Math.ceil(totalItems / pageSize)"
          @change-page="handlePageChange"
        />
      </div>
    </div>

    <!-- Modal para edição -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square icon-text-logout"></i>
            <span class="txt-title-modal"> Editar Cortesia</span>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <div class="row g-2 p-2">
              <!--Código-->
              <div class="col-12 col-sm-12 col-md-12 col-lg-1 col-xl-1">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_codigo"
                  />
                  <label>Código</label>
                </div>
              </div>
              <!--Descrição-->
              <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_descricao"
                  />
                  <label>Descrição</label>
                </div>
              </div>
              <!--Preço Base-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_preco_base_peca"
                    @input="
                      edit_preco_base_peca = formatarValor(edit_preco_base_peca)
                    "
                  />
                  <label>Preço Base</label>
                </div>
              </div>

              <!--Item-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_preco_venda"
                    @input="edit_preco_venda = formatarValor(edit_preco_venda)"
                  />
                  <label>Preço Final</label>
                </div>
              </div>
            </div>
            <div class="row g-2 p-2">
              <!--Tmo Instalação-->
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-md-none">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-x-circle" title="Cancelar"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    @click="update()"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-check-circle" title="Confirmar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                    @click="update()"
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RodapeVue />
  </div>
</template>

<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import Navgator from "../../components/menu/Navgator.vue";
import axios from "axios";
//import DataService from "../../services/DataService";
import userService from "../../services/user.service";
import Pagination from "../../components/Pagination.vue";
import Message from "../../components/modal/Message.vue";

import RodapeVue from "../../components/menu/Rodape.vue";

export default {
  name: "Usuários",
  components: {
    SidebarVue,
    Pagination,
    Message,
    RodapeVue,
    Navgator
  },
  data() {
    return {
      isLoading: false,
      cortesias: [],

      //Mensagens do Sistema
      msg: null,
      abrir_modal: false,
      dialog: false,
      //Campos Cadastro
      user_id: "",
      codigo: "",
      descricao: "",
      preco_base_peca: "",
      preco_venda: "",
      btn_cadastrar: false,

      /// Campos Modal Editar
      edit_id: "",
      edit_codigo: "",
      edit_descricao: "",
      edit_preco_base_peca: "",
      edit_preco_venda: "",

      //Params
      searchTitle: "",
      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSizes: [5, 10, 15, 35],
      pageSize: 50,
      checar: 0,
      currentPage: 1
    };
  },
  mounted() {
    this.retrieveCortesias();
  },
  methods: {
    formatarValor(valor) {
      if (!valor) return "";
      valor = valor.toString().replace(/\D/g, "");
      valor = (valor / 100).toFixed(2).replace(".", ",");
      valor = valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return valor;
    },
    async onSubmit() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}cortesias`,
          {
            method: "POST",

            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              item: this.item,
              cortesia: this.cortesia,
              codigo: this.codigo,
              descricao: this.descricao,
              preco_base_peca: this.preco_base_peca,
              tmo_instalacao: this.tmo_instalação,
              tmo_pintura: this.tmo_pintura,
              preco_venda: this.preco_venda,
              categoria_id: this.categoria_id,
              modelo_id: this.modelo_id,
              mao_obra_id: this.mao_obra_id
            })
          }
        );
        const resp = JSON.stringify(response.status);
        if (resp == 200) {
          this.abrir_modal = true;
          this.msg = "Cortesia criado com sucesso!";
          setTimeout(() => (this.abrir_modal = false), 4000);
          (this.item = ""),
            (this.cortesia = ""),
            (this.codigo = ""),
            (this.descricao = ""),
            (this.preco_base_peca = ""),
            (this.tmo_instalação = ""),
            (this.tmo_pintura = ""),
            (this.preco_venda = ""),
            (this.categoria_id = ""),
            (this.modelo_id = ""),
            (this.mao_obra_id = "");
          this.retrieveCortesias();
        } else {
          this.modal = true;
          this.dialog = true;
          this.message = "Erro ao inserir a cortesia";
          setTimeout(() => (this.dialog = false), 4000);
        }
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    //Buscar dados no banco de dados
    getRequestParams(searchTitle, page, pageSize) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },

    async handlePageChange(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.retrieveCortesias(newPage);
        this.page = newPage;
      } finally {
        this.isLoading = false;
      }
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveCortesias();
    },
    async retrieveCortesias(page = this.page) {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          page,
          this.pageSize
        );
        const response = await userService.getCortesias(params);

        const { cortesias, totalPages, totalItems } = response.data;
        this.cortesias = cortesias;
        this.totalPages = totalPages;
        this.totalItems = totalItems;
        console.log(response.data);
        return true; // Indica sucesso
      } catch (error) {
        console.error("Erro ao buscar cortesias:", error);
        if (error.response?.status === 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
        return false; // Indica falha
      }
    },

    async editar_cortesia(item) {
      console.log(item);
      (this.edit_id = item.id),
        (this.edit_codigo = item.codigo),
        (this.edit_descricao = item.descricao),
        (this.edit_preco_venda = this.currency(item.preco_venda)),
        (this.edit_preco_base_peca = this.currency(item.preco_base_peca));
    },
    async update() {
      const token = this.$store.state.auth.user.accessToken;
      const headers = {
        "x-access-token": token
      };
      const dados = {
        id: this.edit_id,
        codigo: this.edit_codigo,
        descricao: this.edit_descricao,
        preco_base_peca: this.edit_preco_base_peca,
        preco_venda: this.edit_preco_venda
      };

      const response = await axios.put(
        `${process.env.VUE_APP_API_URL}cortesias/${this.edit_id}`,
        dados,
        { headers }
      );
      const resp = JSON.stringify(response.status);
      console.log(resp);
      if (resp == 200) {
        this.abrir_modal = true;
        this.msg = "Cortesia atualizado com sucesso!";
        setTimeout(() => (this.abrir_modal = false), 4000);
        location.reload();
      }
    },
    currency(number) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      }).format(number);
    }
  }
};
</script>
